export class ReshootProduct {
  public ModelId: number;
  public ColorId: number;
  public SizeGroupId: number;

  constructor(init?: Partial<ReshootProduct>) {
    Object.assign(this, init);
  }
}
